import React from "react";
import { Button } from "semantic-ui-react";

import "./styles.css";

function ButtonWithIcon({ icon, label, loading, disabled, onClick, ...rest }) {
  return (
    <div>
      <Button
        primary
        icon={icon}
        size="large"
        className="button-with-icon"
        labelPosition="right"
        content={label}
        loading={loading}
        disabled={disabled}
        onClick={onClick}
        {...rest}
      />
    </div>
  );
}

export default ButtonWithIcon;



// WEBPACK FOOTER //
// ./src/components/ButtonWithIcon/index.jsx